module.exports = __webpack_public_path__ + "static/media/perfil.a3b4e7a4.png";